<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="basic-paragraph2"><span class="body-copy">Executive Book Editor: Elaine H. Brelsford</span></p>
<p class="basic-paragraph2"><span class="body-copy">Copy Editor: Chrystal Abhalter</span></p>
<p class="basic-paragraph2"><span class="body-copy">Graphic Design: Lynda Smith</span></p>
<p class="basic-paragraph2"><span class="body-copy">Cover Design: Michael Buckingham</span></p>
<p class="basic-paragraph1"><span class="body-copy"></span></p>
<p class="basic-paragraph3"><span class="body-copy1"></span></p>
<p class="basic-paragraph3"><span class="body-copy1"></span></p>
<p class="basic-paragraph3"><span class="body-copy1"></span></p>
<p class="copyright"><span class="body-copy1">Cover quilt: Bow Tie Quilt by Martha Dellasega Gray (2007). 62</span><span class="body-copy1">”</span><span class="body-copy1"> x 78</span><span class="body-copy1">”. </span><span class="body-copy1">Hand pieced and hand quilted.</span><span class="body-copy2"></span></p>
</div>
<div class="frame">
</div>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
<div class="frame">
<img alt="100039.png" class="frame2" src="OEBPS/image/100039.png"/>
</div>
<div class="frame">
<img alt="85592.png" class="frame2" src="OEBPS/image/85592.png"/>
</div>
<div class="basic-text-frame">
<p class="basic-paragraph"><span class="title">Dedication</span></p>
<p class="dedication"><span class="byline"></span></p>
<p class="dedication"><span class="byline">I’d like to dedicate this book to my incredible readership that continues to encourage me with compliments and personal experiences as they read my novels. It has made my journey a real pleasure! I will always be grateful. Thank you.</span></p>
<p class="dedication"></p>
</div>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
<div class="basic-text-frame">
<p class="normal"></p>
</div>
<div class="frame">
<img alt="100075.png" class="frame2" src="OEBPS/image/100075.png"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// everlastingquilts_split1.vue?ddc5e488